import { createContext, useContext, type ReactNode } from 'react';
import { trpc } from './trpc';

interface AdminUser {
  id: number;
  username: string;
  name: string | null;
  email: string | null;
  allowedSections: string | null;
}

interface AuthContextValue {
  admin: AdminUser | null;
  isLoading: boolean;
  refetch: () => void;
}

const AuthContext = createContext<AuthContextValue>({
  admin: null,
  isLoading: true,
  refetch: () => {},
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const { data, isLoading, refetch } = trpc.admin.auth.me.useQuery(undefined, {
    retry: false,
  });

  return (
    <AuthContext.Provider value={{ admin: data ?? null, isLoading, refetch }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function useRequireAdmin() {
  const { admin, isLoading } = useAuth();
  return { admin, isLoading, isAuthenticated: !!admin };
}
